import React, { useContext } from 'react';

import { Box } from '@mui/material';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';
import { useParams } from 'react-router-dom';

import { DiscoverContext } from '../../../../context/DiscoverContext';
import { useIsWidthUp } from '../../../../theme';
import { useSERPNavigation } from '../../../../utils/hooks';
import useInsightsMiddleware from '../../../../utils/hooks/useInsightsMiddleware';
import { FiltersOverlay } from '../FiltersOverlay';
import FiltersPanel from '../FiltersPanel';
import ResultsPanel from '../ResultsPanel';
import useStyles from './styles';

interface SERPContainerProps {
  tenantTitle?: string | null;
  tenantName?: string | null;
  linkedInId?: string | null;
  attributesExcludedFromClear?: string[];
  loadingApiKey: boolean;
  userLoading: boolean;
}

export const SERPContainer: React.FC<SERPContainerProps> = ({
  tenantTitle,
  tenantName,
  linkedInId,
  attributesExcludedFromClear,
  loadingApiKey,
  userLoading,
}) => {
  const classes = useStyles();
  const isMobile = !useIsWidthUp('xl');

  const params = useParams();
  const isCategoryPage = !!params?.category;
  const { results } = useInfiniteHits();

  const type = useSERPNavigation();
  const resetTypeFilter = isCategoryPage || type === '';

  const { searchState } = useContext(DiscoverContext);

  useInsightsMiddleware({
    canCheckToken: Boolean(
      !loadingApiKey && process.env.REACT_APP_ALGOLIA_APP_NAME && !userLoading,
    ),
    allowedInsightMethods: ['clickedObjectIDsAfterSearch', 'clickedObjectIDs'],
    queryID: results?.queryID,
  });

  return (
    <Box className={classes.wrapper}>
      <FiltersOverlay attributesExcludedFromClear={attributesExcludedFromClear}>
        <FiltersPanel
          isMobile={isMobile}
          resetTypeFilter={resetTypeFilter}
          isSearching={searchState?.query}
        />
      </FiltersOverlay>
      <ResultsPanel tenantTitle={tenantTitle} tenantName={tenantName} linkedInId={linkedInId} />
    </Box>
  );
};

export default SERPContainer;
